import Link from "next/link";
import React, { FunctionComponent, PropsWithChildren, HTMLAttributeAnchorTarget } from "react";
import { cx, css } from "@adjust/libs/emotion";

const linkCSS = css({
  color: "inherit",
  textDecoration: "underline",
  overflowWrap: "break-word",
});

type LinkProps = {
  href: string;
  target?: HTMLAttributeAnchorTarget;
};

const LinkElementComponent: FunctionComponent<PropsWithChildren<LinkProps>> = ({ href, target, children }) => {
  return (
    <Link href={href} className={linkCSS} target={target}>
      {children}
    </Link>
  );
};

export default LinkElementComponent;
